import Vue from 'vue';
import Router from 'vue-router';
import TopView from '../views/Top';
import AboutView from '../views/About';
import CharacterView from '../views/Character';
import SystemView from '../views/System';
import SitePolicy from '../views/SitePolicy';
import PrivacyPolicy from '../views/PrivacyPolicy';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Top',
      component: TopView,
    },
    {
      path: '/about',
      name: 'About',
      component: AboutView,
    },
    {
      path: '/character',
      name: 'Character',
      component: CharacterView,
    },
    /** System */
    {
      path: '/system',
      name: 'System',
      component: SystemView,
    },
    {
      path: '/site-policy',
      name: 'SitePolicy',
      component: SitePolicy,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
